import { render, staticRenderFns } from "./ViewSubOffice.vue?vue&type=template&id=d6fff10a&scoped=true&"
import script from "./ViewSubOffice.vue?vue&type=script&lang=js&"
export * from "./ViewSubOffice.vue?vue&type=script&lang=js&"
import style0 from "./ViewSubOffice.vue?vue&type=style&index=0&id=d6fff10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fff10a",
  null
  
)

export default component.exports